<template>
  <div class="relative">
    <div class="relative">
      <div class="flex justify-between">
        <div>
          <span class="range-label bold-label">{{minLabel}}</span>
          <currency v-if="availability.class" :value="minValue" class="block" />
          <span class="block" v-else>--</span>
        </div>
        <div class="flex align-items-end justify-center relative upper">
          <span class="range-value mr-2 text-right">{{100 - localClassPercent}}%</span>
          <span class="vertical-separator"></span>
          <span class="range-value ml-2">{{localClassPercent}}%</span>
        </div>
        <div>
          <span class="range-label bold-label text-right">{{maxLabel}}</span>
          <currency v-if="availability.class" :value="maxValue" class="block text-max text-right" />
          <span class="block text-right" v-else>--</span>
        </div>
      </div>
      <div class="range">
        <b-form-input class="range__input"
          id="classPercent"
          v-model="localClassPercent"
          type="range"
          min="0"
          max="100"
          step="5"
          :disabled="classDisabled"
          @change="updateClassBlend">
        </b-form-input>
        <span class="range__fill" :style="{ width: `${localClassPercent}%` }"></span>
      </div>
    </div>
    <div class="alert alert-success flex md:justify-between md:items-center">
      <span>Blended Expected Price</span>
      <currency v-if="availability.class" class="font-bold text-lg" :value="blendedExpectedPrice" />
      <span v-else>--</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import Currency from './Currency.vue';

export default {
  props: {
    data: Object,
    minValue: Number,
    maxValue: Number,
    initial: String,
  },
  components: {
    Currency,
  },
  data() {
    return {
      debug: true,
      localClassPercent: ((Number(this.initial) * 100) - 100).toString(),
      minLabel: this.data.minLabel,
      maxLabel: this.data.maxLabel,
    };
  },
  computed: {
    ...mapState(['availability', 'classIns', 'insuranceBlend', 'loading', 'quarter']),
    ...mapGetters(['classDisabled']),

    blendedExpectedPrice() {
      const {
        localClassPercent,
        minValue,
        maxValue,
      } = this;

      return minValue + ((Number(localClassPercent) * ((maxValue - minValue) / 100)));
    },

    classIIIPriceDisplay() {
      const localClassPercentNum = Number(this.localClassPercent);
      return (localClassPercentNum === 0) ? '--' : 100 - localClassPercentNum;
    },

    classIVPriceDisplay() {
      const localClassPercentNum = Number(this.localClassPercent);
      return (localClassPercentNum === 0) ? '--' : localClassPercentNum;
    },
  },

  watch: {
    quarter(newValue) {
      if (newValue && this.availability.class) this.localClassPercent = '0';
      this.$forceUpdate();
    },
    availability(newValue) {
      if (!newValue.class) this.localClassPercent = '0';
      if (!newValue.componentClassIV && !newValue.componentClassIII) this.localClassPercent = '0';
    },
    classWeightingFactor(newValue) {
      const newSliderValue = (Number(newValue) * 100).toString();
      if (newSliderValue !== this.localClassPercent) {
        this.localClassPercent = newSliderValue;
      }
    },
  },

  methods: {
    ...mapMutations([
      'updateClassPercent',
    ]),
    updateClassBlend() {
      const { localClassPercent } = this;
      if (this.debug) console.log(`updateClassBlend(${localClassPercent})`);
      this.$store.commit('updateClassPercent', parseFloat(localClassPercent));
    },
  },
};
</script>

<style>
.upper {
  flex: 0 1 auto;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 20%;
  z-index: -1;
}
</style>
